import { useMemo } from 'react'

import type { AppUser } from '../../../types/app'

import { Countdown } from './Countdown/Countdown'
import {
  StyledContainer,
  StyledHeaderUser,
  StyledLogo,
  StyledLogoLink,
  StyledTopContainer,
} from './Header.Styled'
import type { HeaderProps } from './Header.Types'

export const Header = ({
  backgroundStyle,
  containerRef,
  emailUser,
  logoLink,
  onCountdownCtaClick,
  pageConfig,
}: HeaderProps) => {
  const hasCountdown = Boolean(pageConfig.countdownExpirationMillis)

  const user = useMemo<Omit<AppUser, 'uid'> | undefined>(() => {
    if (emailUser) {
      return {
        ...emailUser,
        type: 'email',
      }
    }
    return undefined
  }, [emailUser])

  return (
    <StyledContainer ref={containerRef}>
      <StyledTopContainer $backgroundStyle={backgroundStyle}>
        {logoLink ? (
          <StyledLogoLink href={logoLink}>
            <StyledLogo />
          </StyledLogoLink>
        ) : (
          <StyledLogo />
        )}
        {user && <StyledHeaderUser user={user} />}
      </StyledTopContainer>
      {hasCountdown && (
        <Countdown
          expirationMillis={pageConfig.countdownExpirationMillis}
          onCtaClick={onCountdownCtaClick}
        />
      )}
    </StyledContainer>
  )
}
